import { Navigate, useLocation } from 'react-router-dom'
import { LoadingOverlay } from '@mantine/core'
import { useAuth } from '../../context/AuthContext'

const SUBSCRIPTION_EXEMPT = ['/dashboard', '/payment', '/subscription', '/profile']

function isSubscriptionExpired(endDate: string | null | undefined): boolean {
  if (!endDate) return false
  return new Date(endDate) < new Date()
}

interface Props {
  children: React.ReactNode
  roles?: string[]
}

export function ProtectedRoute({ children, roles }: Props) {
  const { user, isLoading } = useAuth()
  const { pathname } = useLocation()

  if (isLoading) return <LoadingOverlay visible />

  if (!user) return <Navigate to="/login" replace />

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />
  }

  if (
    user.role === 'student' &&
    user.subscription_status === 'active' &&
    isSubscriptionExpired(user.subscription_end_date) &&
    !SUBSCRIPTION_EXEMPT.some((p) => pathname.startsWith(p))
  ) {
    return <Navigate to="/payment?reason=subscription-expired" replace />
  }

  return <>{children}</>
}
